import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { EquipmentService } from '../../../shared/service/equipment.service';
import { Attending } from '../../model/attending';
import { Equipment } from '../../../shared/model/equipment';
import { Configuration } from '../../model/configuration';
import { SimCardService } from '../../../shared/service/sim-card.service';
import { SimCard } from '../../../shared/model/sim-card';
import { Access } from '../../../shared/model/access';
import { AuthenticationService } from '../../../shared/service/authentication.service';
import { ScreeningService } from '../../service/screening.service';
import { ConfigurationTypes } from '../../model/configuration-types';
import { JiraTicketService } from '../../../appraisal/service/jira-ticket.service';

declare var Materialize: any;

@Component({
  selector: 'tx-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit, AfterViewChecked {
  private _attending: Attending = new Attending();
  @Input() editable: boolean;
  @Output() txOnSave: EventEmitter<any> = new EventEmitter();
  @Output() txOnCancel: EventEmitter<any> = new EventEmitter();

  equipmentAttributesTree = ['serial'];
  simCardAttributesTree = ['iccid'];
  equipments: Array<Equipment> = new Array();
  simCards: Array<SimCard> = new Array();
  authenticatedUser: any;
  configurationTypes: any;

  CONFIGURATION = 'CONFIGURATION';

  EQUIPMENT_AVAILABLE_STATUS = 'CONFIGURACAO';

  constructor(private _equipmentService: EquipmentService,
              private _simCardService: SimCardService,
              private _authService: AuthenticationService,
              private _screeningService: ScreeningService,
              private _jiraTicketService: JiraTicketService) {
    this.setUpObservers();
    this._screeningService.findConfigurationTypes();
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set attending(attending) {
    this._attending = attending;
    this.setEmptyEntities();
    this.showStep();
    if (this.canEdit()) {
      this._jiraTicketService.findJiraTicket(attending.jiraTicket);
    }
  }

  save() {
    this.txOnSave.emit(this.attending);
  }

  cancel() {
    this.txOnCancel.emit();
  }

  findEquipmentBySerialAndStatus(serial) {
    this._equipmentService.findBySerialAndStatus(serial, this.EQUIPMENT_AVAILABLE_STATUS);
  }

  findByIccid(iccid) {
    this._simCardService.findAvailableSimCardsWithAccessByIccidContains(iccid);
  }

  setEquipment(equipment) {
    this.attending.attendingEquipmentInfo.equipmentChosenForAttending = equipment;
    this.attending.configuration.equipmentModel = equipment.equipmentModel;
    this.attending.configuration.simCard = equipment.simCard;
  }

  canEdit() {
    return (this.attending.configuration.canEdit || this.attending.configuration.canEdit === undefined) && this.editable;
  }

  canView() {
    return this.attending.configuration.canView && !this.canEdit();
  }

  showStep() {
    if (this.attending.orderedSteps && this.attending.currentStep === this.CONFIGURATION) {
      this.setIsVisible();
      this.setIsEditable();
    }
  }

  private resolveJiraTicketResult(jiraTicket) {
    this.resolveJiraTickeTOS(jiraTicket);
  }

  private resolveJiraTickeTOS(jiraTicket) {
    if (jiraTicket.os) {
      this.attending.serviceOrder = jiraTicket.os;
    }
  }

  private setIsVisible() {
    if (this.attending.orderedSteps.includes(this.CONFIGURATION)
        && this.authenticatedUser.stepViews.find(view => view.stepViewType === this.CONFIGURATION)) {
      this.attending.configuration.canView = true;
    } else {
      this.attending.configuration.canView = false;
    }
  }

  private setIsEditable() {
    if (this.authenticatedUser.stepKeys.find(view => view.stepType === this.CONFIGURATION)) {
      this.attending.configuration.canEdit = true;
    } else {
      this.attending.configuration.canEdit = false;
    }
  }

  private setUpObservers() {
    this._jiraTicketService.find$
      .subscribe((jiraTicket) => this.resolveJiraTicketResult(jiraTicket));

    this._equipmentService.find$
      .subscribe(equipments => this.equipments = equipments);

    this._simCardService.find$
      .subscribe(simCards => this.simCards = simCards);

    this._screeningService.find$
      .filter(result => result instanceof ConfigurationTypes)
      .subscribe(configurationTypes => {
        this.configurationTypes = configurationTypes;
      });
  }

  private setEmptyEntities() {
    this.authenticatedUser = this._authService.getUserFromLocalStorage();
    if (!this.attending.configuration) {
      this.attending.configuration = new Configuration();
    }
    if (!this.attending.configuration.simCard) {
      this.attending.configuration.simCard = new SimCard();
      this.attending.configuration.simCard.access = new Access();
    }
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/configuration/configuration.component.ts